import Confirm from "./Confirm";

export default class DesignConfirm extends Confirm {

}